'use client';

import { useMediaQuery, useTheme, Box, Grid } from '@mui/material';

import { tss } from 'tss-react/mui';

import { NewsTasksCard } from '../../../modules/home/NewsTasksCard';
import { NewsEventsCollection } from '../../../modules/home/NewsEventsCollection';
import { GovernorhubBlog } from '../../../modules/home/GovernorhubBlog';
import { PendingInvitesBanner } from '../../../modules/home/PendingInvitesBanner';

import { Newsfeed } from './_components/Newsfeed';

const useStyles = tss.create(({ theme }) => {
  return {
    sidebarPanelMarginBottom: {
      marginBottom: theme.spacing(3),
    },
  };
});

const NewsPage = () => {
  const { classes } = useStyles();

  const theme = useTheme();
  const matchesDesktop = useMediaQuery(theme.breakpoints.up('md'));

  return (
    <Box sx={{ width: '100%' }}>
      <PendingInvitesBanner />
      <Grid container spacing={2}>
        <Grid
          flex="auto"
          size={{
            md: 8,
          }}
        >
          <Newsfeed />
        </Grid>
        {matchesDesktop && (
          <Grid
            size={{
              md: 4,
            }}
          >
            <div>
              <NewsTasksCard className={classes.sidebarPanelMarginBottom} />
              <NewsEventsCollection
                className={classes.sidebarPanelMarginBottom}
              />
              <GovernorhubBlog className={classes.sidebarPanelMarginBottom} />
            </div>
          </Grid>
        )}
      </Grid>
    </Box>
  );
};

export default NewsPage;
